export default "__VITE_ASSET__BWBS3G1S__"